import GoogleAnalyticsConsts from '../../const/GoogleAnalyticsConsts'
import GoogleAnalyticsUtils from '../../components/utils/GoogleAnalyticsUtils'
import { NavigationPages } from '../navigation/navigation-pages'
import { notifyTelegramBot } from '../../shared/http/telegram-notification'
import { goToPageNotPremium } from '../../components/utils/goToPage'
import { NavigateFunction } from 'react-router-dom'

export const buyPromoCode30 = (): void => {
    notifyTelegramBot('Хочет купить 30 дней')
    const url: string = 'https://auth.robokassa.ru/RecurringSubscriptionPage/Subscription/Subscribe?SubscriptionId=19dd2801-289f-4d93-ae90-b5f9d78050b6'
    window.open(url, '_blank')?.focus()
    GoogleAnalyticsUtils.createEvent(GoogleAnalyticsConsts.PREMIUM_OPEN_BUY_PREMIUM_30)
}

export const buyPromoCode365 = (): void => {
    notifyTelegramBot('Хочет купить 365 дней')
    const url: string = 'https://auth.robokassa.ru/RecurringSubscriptionPage/Subscription/Subscribe?SubscriptionId=985129a0-9155-4584-8965-3a8fefab505b'
    window.open(url, '_blank')?.focus()
    GoogleAnalyticsUtils.createEvent(GoogleAnalyticsConsts.PREMIUM_OPEN_BUY_PREMIUM_365)
}

export const buyPromoCode90 = (): void => {
    notifyTelegramBot('Хочет купить 3 месяца по акции')
    const url: string = 'https://auth.robokassa.ru/RecurringSubscriptionPage/Subscription/Subscribe?SubscriptionId=97a91019-139a-49fa-b95c-f0834120b844'
    window.open(url, '_blank')?.focus()
    GoogleAnalyticsUtils.createEvent(GoogleAnalyticsConsts.PREMIUM_OPEN_BUY_PREMIUM_365)
}

export const openPremiumPage = (navigate: NavigateFunction): void => {
    goToPageNotPremium(NavigationPages.PREMIUM, navigate)
}